<template>
  <div>
    <ds-heading text="Tabela do INSS" />

    <ds-row>
      <ds-col size="2">
        <ds-button full-width @click="onPrevious">Anterior</ds-button>
      </ds-col>
      <ds-col size="5" offset="1">
        <ds-heading
          :text="`Válido de ${inssTable.initialDate} até ${inssTable.finalDate}`"
          size="sm"
          class="ds-u-text-align--center">
        </ds-heading>
      </ds-col>
      <ds-col
        size="2"
        offset="2"
        align="right">
        <ds-button full-width @click="onNext">Próxima</ds-button>
      </ds-col>
    </ds-row>

    <ds-row>
      <ds-col>
        <ds-page>
          <ds-row>
            <ds-col size="11">
              <ds-heading
                size="md"
                class="ds-u-text-align--center"
                text="Trabalhadores">
              </ds-heading>
            </ds-col>
          </ds-row>
          <ds-row>
            <ds-col align="right" size="5">
              <ds-heading size="sm" text="Rendimentos Até:" />
            </ds-col>
            <ds-col offset="1" size="4">
              <ds-heading size="sm" text="Alíquota do INSS:" />
            </ds-col>
          </ds-row>
          <ds-row v-for="(workerRange, index) in inssTable.workerRanges" :key="index">
            <ds-col align="right" size="5">
              R$ {{ workerRange.ceiling | caCurrency }}
            </ds-col>
            <ds-col align="center" size="1">
              <ds-icon size="sm" icon="arrow-right" />
            </ds-col>
            <ds-col size="5">
              {{ workerRange.percent | caCurrency }} %
            </ds-col>
          </ds-row>

          <ds-row>
            <ds-col align="right" size="5">
              <ds-heading size="sm" text="Rendimentos Até:" />
            </ds-col>
            <ds-col offset="1" size="4">
              <ds-heading size="sm" text="Valor do Salário Família:" />
            </ds-col>
          </ds-row>
          <ds-row>
            <ds-col align="right" size="5">
              R$ {{ inssTable.rendSalFam1 | caCurrency }}
            </ds-col>
            <ds-col align="center" size="1">
              <ds-icon size="sm" icon="arrow-right" />
            </ds-col>
            <ds-col size="5">
              R$ {{ inssTable.valSalFam1 | caCurrency }}
            </ds-col>
          </ds-row>
          <ds-row v-if="hasSecondSalaryFamily">
            <ds-col align="right" size="5">
              R$ {{ inssTable.rendSalFam2 | caCurrency }}
            </ds-col>
            <ds-col align="center" size="1">
              <ds-icon size="sm" icon="arrow-right" />
            </ds-col>
            <ds-col size="5">
              R$ {{ inssTable.valSalFam2 | caCurrency }}
            </ds-col>
          </ds-row>

          <ds-row>
            <ds-col size="11">
              <ds-heading
                size="md"
                class="ds-u-text-align--center"
                text="Diretores" />
            </ds-col>
          </ds-row>
          <ds-row>
            <ds-col align="right" size="5">
              <ds-heading size="sm" text="Rendimentos Até:" />
            </ds-col>
            <ds-col offset="1" size="4">
              <ds-heading size="sm" text="Alíquota do INSS:" />
            </ds-col>
          </ds-row>
          <ds-row v-for="(partnerRange, index) in inssTable.partnerRanges" :key="index+100">
            <ds-col align="right" size="5">
              R$ {{ partnerRange.ceiling | caCurrency }}
            </ds-col>
            <ds-col align="center" size="1">
              <ds-icon size="sm" icon="arrow-right" />
            </ds-col>
            <ds-col size="5">
              {{ partnerRange.percent | caCurrency }} %
            </ds-col>
          </ds-row>

          <ds-row>
            <ds-col size="11">
              <ds-heading
                size="md"
                class="ds-u-text-align--center"
                text="Autônomos" />
            </ds-col>
          </ds-row>
          <ds-row>
            <ds-col align="right" size="5">
              <ds-heading size="sm" text="Rendimentos Até:" />
            </ds-col>
            <ds-col offset="1" size="4">
              <ds-heading size="sm" text="Alíquota do INSS:" />
            </ds-col>
          </ds-row>
          <ds-row
            v-for="(selfEmployedRange, index) in inssTable.selfEmployedRanges"
            :key="index+200">
            <ds-col align="right" size="5">
              R$ {{ selfEmployedRange.ceiling | caCurrency }}
            </ds-col>
            <ds-col align="center" size="1">
              <ds-icon size="sm" icon="arrow-right" />
            </ds-col>
            <ds-col size="5">
              De acordo com alíquota definida no cadastro.
            </ds-col>
          </ds-row>
        </ds-page>
      </ds-col>
    </ds-row>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import {
  getNextInssTable,
  getPreviousInssTable,
  getCurrentInssTable,
} from './inssTableService';

library.add(faArrowRight);

export default {
  name: 'InssTablePage',
  data() {
    return {
      inssTable: {},
    };
  },
  computed: {
    hasSecondSalaryFamily() {
      return this.inssTable.rendSalFam2;
    },
  },
  created() {
    this.setCurrentInssTable();
  },
  methods: {
    async setCurrentInssTable() {
      this.inssTable = await getCurrentInssTable();
    },
    async onPrevious() {
      await getPreviousInssTable(this.inssTable.id)
        .then(result => {
          if (!result) {
            this.$toaster.warning('Não existe tabela anterior.');
            return;
          }
          this.inssTable = result;
        })
        .catch(() => {
          this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
        });
    },
    async onNext() {
      await getNextInssTable(this.inssTable.id)
        .then(result => {
          if (!result) {
            this.$toaster.warning('Não existe tabela posterior.');
            return;
          }
          this.inssTable = result;
        })
        .catch(() => {
          this.$toaster.error('Aconteceu um erro, por favor tente novamente.');
        });
    },
  },
};
</script>
